import { env } from "@shared/config/env";
import { useSettingsStore } from "@shared/store/settings.store";
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@shared/ui/sidebar";
import { Command } from "lucide-react";
import { NavMain } from "./nav-main";
import { NavSecondary } from "./nav-secondary";
import { NavTables } from "./nav-tables";
import { NavUser } from "./nav-user";

export function AppSidebar() {
	const { sidebarCollapsible, sidebarVariant } = useSettingsStore();

	return (
		<Sidebar collapsible={sidebarCollapsible} variant={sidebarVariant} className="h-svh">
			<SidebarHeader>
				<SidebarMenu>
					<SidebarMenuItem>
						<SidebarMenuButton size="lg" className="hover:bg-transparent!">
							<div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
								<Command className="size-4" />
							</div>
							<div className="grid flex-1 text-left text-sm leading-tight">
								<span className="truncate font-medium">{env.VITE_CUSTOMER_NAME}</span>
							</div>
						</SidebarMenuButton>
					</SidebarMenuItem>
				</SidebarMenu>
			</SidebarHeader>
			<SidebarContent>
				<NavMain />
				<NavTables />
				<NavSecondary />
			</SidebarContent>
			<SidebarFooter>
				<NavUser />
			</SidebarFooter>
		</Sidebar>
	);
}
